module.exports = __webpack_public_path__ + "img/go-back.d0745566.png";